import { Component } from "@angular/core";
import { BaseModalComponent } from "@ha/ui/common";

@Component({
    selector: "pmt-premium-info-modal",
    templateUrl: "./premium-info-modal.component.html",
    styleUrls: ["./premium-info-modal.component.scss"],
})
export class PremiumInfoModalComponent extends BaseModalComponent {
    busy = false;

    close(): void {
        this.closeModal();
    }

    openPremiumDemo(): void {
        window.open("https://www.hetaarbeten.se/sv/digitala-tjanster/heta-arbeten-premium/boka-demo/", "_blank");
    }
}
